"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReplaceContractDto = instanceOfReplaceContractDto;
exports.ReplaceContractDtoFromJSON = ReplaceContractDtoFromJSON;
exports.ReplaceContractDtoFromJSONTyped = ReplaceContractDtoFromJSONTyped;
exports.ReplaceContractDtoToJSON = ReplaceContractDtoToJSON;
exports.ReplaceContractDtoToJSONTyped = ReplaceContractDtoToJSONTyped;
/**
 * Check if a given object implements the ReplaceContractDto interface.
 */
function instanceOfReplaceContractDto(value) {
    if (!('offerId' in value) || value['offerId'] === undefined)
        return false;
    if (!('templateId' in value) || value['templateId'] === undefined)
        return false;
    if (!('mode' in value) || value['mode'] === undefined)
        return false;
    return true;
}
function ReplaceContractDtoFromJSON(json) {
    return ReplaceContractDtoFromJSONTyped(json, false);
}
function ReplaceContractDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'offerId': json['offerId'],
        'templateId': json['templateId'],
        'mode': json['mode'],
        'additionalData': json['additionalData'] == null ? undefined : json['additionalData'],
    };
}
function ReplaceContractDtoToJSON(json) {
    return ReplaceContractDtoToJSONTyped(json, false);
}
function ReplaceContractDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'offerId': value['offerId'],
        'templateId': value['templateId'],
        'mode': value['mode'],
        'additionalData': value['additionalData'],
    };
}
